import { makeStyles } from '@material-ui/styles';
import { Dropdown, MenuLine } from '@bizzabo/design-system';
import React from 'react';

interface ItemDropdownMenuProps {
    children: React.ReactElement | ((closeDropdown: () => void) => React.ReactElement);
}

const ItemDropdownMenu: React.FC<ItemDropdownMenuProps> = ({ children }) => {
    const classes = useStyles();
    return (
        <Dropdown button={() => <MenuLine />} placement="bottom-end">
            {(closeDropdown: () => void) => (
                <div className={classes.dropdownMenuContent}>
                    {typeof children === 'function' ? children(closeDropdown) : children}
                </div>
            )}
        </Dropdown>
    );
};

const useStyles = makeStyles(
    theme => ({
        dropdownMenuContent: {
            padding: '6px 10px 8px 10px',
            boxShadow: '0px 4px 14px rgba(64, 64, 64, 0.1)',
            borderRadius: 12,
            backgroundColor: theme.customization.background.C10,
        },
        menuButton: {
            ...theme.typography.t81,
            height: 26,
            border: 0,
            borderRadius: 6,
            width: '100%',
            '& *': {
                textAlign: 'left',
            },
            marginTop: 4,
        },
    }),
    { classNamePrefix: 'meetings-item-dropdown' }
);

export default ItemDropdownMenu;
